jQuery( $ => {

    var blocks = document.querySelectorAll( '.vertical-slider--block' );
    const headerHeight = document.getElementById('masthead').offsetHeight;
    const slideHeight = 600;

    const setSizes = function () {
        
        // const isLarge = $.screenSize("lg");

        const isLarge = true;

        for ( var i = 0; i < blocks.length; i++ ) {

            const block = blocks[ i ];
            // let heading = block.querySelector('.heading');
            let slides = block.querySelectorAll('.slide');
            
            if( slides ){
                slides = Array.from(slides);
            }

            const totalSlides = slides.length;

            $(block).css("padding-bottom", isLarge ? 100 * totalSlides : "").css("height", isLarge ? slideHeight * (totalSlides + 1) : "");
            
            slides.forEach( slide => {
                slide.classList.remove('visible');
                slide.classList.remove('hidden');
            } )

        }

    };

    // init
    if( blocks ){

        setSizes(blocks);

        // window resize
        $(window).on("resize", () => setSizes(blocks) );
        
        // Window scroll
        $(window).on("scroll", () => handleScrollEvent(blocks) );

        // set 1st block to visible
        blocks.forEach( block => block.querySelector( '.slide:first-of-type' ).classList.add('visible') );
    }


    function handleScrollEvent() {

        const scroll = $(window).scrollTop();
        // const isLarge = $.screenSize("lg");

        const isLarge = true;

        $(blocks).each( function () {

            const wrapper = $(this).find(".slider-container");
            const top = $(this).offset().top - headerHeight;
            const height = $(this).height() + parseInt($(this).css("padding-bottom"));
            const bottom = top + height + headerHeight;
            const slides = $(this).find(".slide");

            if (scroll < top || scroll > bottom || !isLarge) {

                wrapper.css("top", "").toggleClass("fixed", false);

            } else {

                wrapper.css("top", `${headerHeight}px`).toggleClass("fixed", true);

                const currentSlide = Math.min( slides.length, Math.floor((scroll - top) / slideHeight) + 1 ) - 1;

                slides.each( (i, slide) => {

                    if( i == currentSlide ){
                        slide.classList.remove('hidden');
                        slide.classList.add('visible');
                    }

                    if( i != currentSlide ){
                        slide.classList.add('hidden');
                        slide.classList.remove('visible');
                    }
                    
                    if( currentSlide == slides.length ){
                        slides[ slides.length ].classList.add('visible');
                        slides[ slides.length ].classList.remove('hidden');
                    }

                } )
            }
        });
    }
});

